import Layout from '@/components/layout/Layout'
import { useAuth } from '@/context/AuthContext'
import { HeaderControlsProvider } from '@/context/HeaderControlsContext'
import { SupportSessionBanner } from '@/context/SupportSessionContext'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'
import { useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

import {
  DroidMapMetadata,
  StandardOrgIds,
} from '@droidmap/shared-service-contract'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location, context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
    // Initialize metadata for the authenticated routes, orgId and projectId can be undefined
    const metadata: DroidMapMetadata = {
      // TODO: Remove this once we have updated backend permissions
      // This is currently used as an initial value, all clients will update the metadata
      orgId: StandardOrgIds.SYSTEM,
      userId: context.auth.userDetails.id,
    }
    return { metadata }
  },
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  const auth = useAuth()
  const router = useRouter()

  // This will catch the state update when a user is logged out
  useEffect(() => {
    if (!auth.isAuthenticated) {
      router.navigate({ to: '/login' })
    }
  }, [auth.isAuthenticated, router])

  return (
    <div className="h-full flex justify-center">
      {/* A column, so the support-session banner takes its height from the
          app's rather than adding to it: stacked on a full-height layout it
          overflows the clipped root, and focusing anything scrolls it away. */}
      <div className="flex h-full w-full flex-col">
        <SupportSessionBanner />
        <div className="min-h-0 flex-1">
          <HeaderControlsProvider>
            <Layout>
              <Outlet />
            </Layout>
          </HeaderControlsProvider>
        </div>
      </div>
    </div>
  )
}
